import React from 'react';

import {useParams, useQuery} from 'views/module';
import CaregiverProfile from 'views/scenes/caregiver_profile/CaregiverProfile';
import FooterSection from 'views/module/appbar/footer/FooterSection';

const Profile = (props) => {
  const params = useParams();
  const query = useQuery();

  return (
    <>
      <CaregiverProfile
        caregiverRn={params.caregiverRn}
        recommendationId={query.recommendation}
      />
      <FooterSection/>
    </>
  );
};

Profile.propTypes = {
};

export default React.memo(Profile);

